export function showMoreButton () {
	if (document.getElementById("showMoreButton")) {
		document.addEventListener("DOMContentLoaded", function () {
			const showMoreButton = document.getElementById("showMoreButton");
			const hiddenRows = document.querySelectorAll(".recruitment-table tbody tr.hidden");
			showMoreButton.addEventListener("click", (event) => {
				event.preventDefault(); // Ngăn chặn hành vi mặc định
				hiddenRows.forEach((row) => row.classList.remove("hidden")); // Hiển thị các dòng bị ẩn
			});
		});
	}
}
